<template>
  <div class="no-content">
    <img src="/liquor/暂无内容 （金装版）.png" />
    <div>开发中，尽情期待！</div>
  </div>
</template>

<script>
export default {
  name: "NoContent"
};
</script>

<style lang="scss">
.no-content {
  width: 100%;
  margin: 200px auto;
  text-align: center;
}
</style>